import React from 'react';

import ProductTile from '../../product/components/product-tile';
import ProductListingHeroBanner from './product-listing-hero-banner';
import ResultsFooterBanner from './results-footer-banner';
import useProductPrice from '../../hooks/useProductPrice';
import useAddToCart from '../../hooks/useAddToCart';
import useProductCompare from '../../hooks/useProductCompare';
import getProductProps from '../../product/get-product-props';

import './vwa-product-list.less';

export default function VWAProductList({ products, children }) {
    const { prices } = useProductPrice(products);
    const compare = useProductCompare();
    const { addedToCart, ...addToCart } = useAddToCart(true);

    return (
        <div className="vwaListContainer">
            <ProductListingHeroBanner />
            <div className="vwaList">
                {products.map((product, i) => (
                    <ProductTile
                        key={`vwa-productTile-${i}`}
                        className="productTile"
                        {...getProductProps(
                            product,
                            prices[product.sku],
                            {
                                addToCart,
                                compare,
                            },
                            { resizeImage: true }
                        )}
                        successPurchaseButton={addedToCart[product.sku]}
                    />
                ))}
                {children}
            </div>
            <ResultsFooterBanner />
        </div>
    );
}
